import styles from "./style.module.scss";
/**
 * Render loading blur filter on graphs
 */
const LoadingBlurFilter = () => {
    return <div className={styles["graph-loading"]} />;
};

export default LoadingBlurFilter;
